<template>
  <v-master>
    <div class="sm:pt-20 container relative max-w-lg pt-10">
      <div>
        <h1 class="title-1 mb-8 text-center">
          Learn more about Carbonii before taking the quiz
        </h1>
        <div class="flex">
          <iframe
            width="550"
            height="450"
            src="https://www.youtube.com/embed/Rb0UmrCXxVA"
            title="The Best of Mozart"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          />
        </div>
        <div>
          <router-link
            :to="'/quiz/country'"
            class="btn btn-primary w-full mt-5"
          >
            Begin the quiz
          </router-link>
        </div>
      </div>
    </div>
  </v-master>
</template>
<script>
export default {
  name: "v-tutorial",

};
</script>
